import { Component, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { DesignService } from '../services/designs.service';
import { AuthService } from '../services/auth.service';
import { GithubService } from '../services/github.service';
import { UserdataService } from '../services/userdata.service';
import { WindowRefService, ICustomWindow } from '../services/window.service';
import * as LogRocket from 'logrocket';

declare var tribed:any;

@Component({
  selector: 'home',
  styleUrls: ['./home.component.css'],
  templateUrl: './home.component.html'
})


export class HomeComponent implements OnInit {

  private _window: ICustomWindow;

	constructor(
    private DesignService: DesignService,
    private auth: AuthService,
    private router: Router,
    private github: GithubService,
    private userDataService: UserdataService,
    windowRef: WindowRefService
	) {
    // get reference to window
    this._window = windowRef.nativeWindow
  };

  previewTheme: any = false;
  themes: any;
  user: any;
  location = 'Home';
  
	ngOnInit() {

    // get currently authed user
    this.auth.getAuthState()
      .subscribe((user) => {

        this.user = user

        // if we have a user, redirect to build page
        if(this.user){
          // navigate to build 
          // this.router.navigate(['/build'], {queryParams: {} })
          // console.log('user:', this.user)
        }
      });

    

    // get designs
    this.themes = this.DesignService.getThemes();

  }

  public scrollToWhyAccess(){
    document.getElementById('whyAccess').scrollIntoView();
  }

  public showThemePreview(theme){

    this.previewTheme = theme;

    // track in SA
    if(this._window.sa_event){
      this._window.sa_event("view-theme");
    }

  }

  public closeThemePreview(){
    this.previewTheme = false;
  }

  public loginWithGithub() {
    this.auth.loginWithGithub()
      .then(data => {
        console.log("login w/Github:", data);

        // track in SA
        if(this._window.sa_event){
          this._window.sa_event('login-with-'+data.credential.providerId);
        }

        tribed("trait", "user_id", data.user.uid);
        tribed("trait", "email", data.user.email);
        tribed("trait", "name", data.user.displayName);
        tribed("trait", "avatar", data.user.photoURL);
        
        LogRocket.identify(data.user.uid, {
          name: data.user.displayName,
          email: data.user.email
        });

        // save loginData in DB
        this.userDataService.saveUserLoginData(data);

        // if user is new, send em to builder and handhold
        if(data.additionalUserInfo.isNewUser){
          // navigate to build with query param
          this.router.navigate(['/build'], {queryParams: {"newb": "y"} });
          tribed("event", "sign-up");
        } else {
          // navigate to build without query param
          this.router.navigate(['/build'], {queryParams: {} });
          tribed("event", "log-in");
        }


      })
      .catch(error => {
        console.log('error:', error)
        alert('something went wrong signing in: ' + error);
      })
  }

  public nextClicked(){
    // navigate to builder
    this.router.navigate(['/build']);
  }

}





// WEBPACK FOOTER //
// ./src/app/home/home.component.ts